<template>
    <div v-if="!loading" class="box">
        <div class="box-header">
            <CFormInput v-model="userFilter" placeholder="Поиск" autocomplete="off" />
        </div>
    </div>
    <div v-if="loading" class="row">
        <div class="loader"></div>
    </div>
    <div v-if="!loading" class="row">
        <div v-for="(user, idx) of paginatedFilteredList" :key="idx" class="col-sm-12 col-md-4 col-xl-4">
            <div class="box box-danger">
                <div class="box-header d-flex justify-content-between align-content-center">
                    <h3 class="box-title" style="font-size: 12px; word-break: break-all;">{{ user.user }}</h3>
                </div>
                <div class="box-footer d-grid gap-2">
                    <button type="button" class="btn btn-block btn-default btn-sm" @click="copyUserToDivision(user)">
                        Копировать
                    </button>
                    <button type="button" class="btn btn-block btn-default btn-sm" @click="moveUserToDivision(user)">
                        Перенести
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <Pagination v-if="!loading" :currentPage="page" :totalPages="Math.ceil(filteredSortedList.length / 12)"
                    @update:currentPage="(p) => { page = p }" :maxVisiblePages="5" />
    </div>
</template>

<script>
import { ApiSys } from '@/services/api';
import { CFormInput, CModal, CModalBody, CModalHeader, CModalTitle } from '@coreui/bootstrap-vue';
import Pagination from '@/components/Pagination.vue';
export default {
    name: "AddUsersToDivision",
    components: { CFormInput, CModal, CModalBody, CModalHeader, CModalTitle, Pagination },
    emits: ["updateTree"],
    props: {
        division: Object,
        hide: Function
    },
    data() {
        return {
            userFilter: '',
            allUsers: [],
            page: 1,
            loading: true,
        }
    },
    setup() {
    },
    watch: {
        userFilter() {
            this.page = 1;
        }
    },
    computed: {
        filteredSortedList() {
            return this.allUsers
                .filter(u => u.user.toLowerCase().includes(this.userFilter.toLowerCase()))
        },
        paginatedFilteredList() {
            return this.filteredSortedList
                .slice((this.page - 1) * 12, this.page * 12)
        }
    },
    async created() {
        this.loading = true;
        this.allUsers = await ApiSys.getAdminUsers();
        this.loading = false;
    },
    methods: {
        async copyUserToDivision(user) {
            let answer = confirm(`Пользователь будет добавлен в "${this.division.name}", продолжить?`);

            if (answer) {
                const result = await ApiSys.addUserDivisionAdmin(user.user, this.division.id);
                if (result.error) {
                    this.$toast.error(result.error.message);
                } else {
                    this.$toast.success('Пользователь успешно добавлен в площадку!');
                    this.hide();
                    this.$emit('updateTree');
                }
            }
        },
        async moveUserToDivision(user) {
            let answer = confirm(`Пользователь будет удален из всех площадок и добавлен только в "${this.division.name}", продолжить?`);

            if (answer) {
                const result = await ApiSys.setUserDivisionAdmin(user.user, this.division.id);
                if (result.error) {
                    this.$toast.error(result.error.message);
                } else {
                    this.$toast.success('Пользователь успешно перенесен в площадку!');
                    this.hide();
                    this.$emit('updateTree');
                }
            }
        }
    },
}
</script>

<style scoped>
.loader {
    width: 64px;
    margin: auto;
    height: 64px;
    border: 3px solid #FFF;
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation .6s linear infinite;
}

@keyframes rotation {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>